/**
 * Created by Jerker Nord on 2023-01-19.
 */
import {BenjiKIVSymbol} from "./BenjiKIVSymbol";
import {BenjiKIV} from "../BenjiKIV";
import {BenjiKIVSpine} from "../components/BenjiKIVSpine";
import {SpineUtils} from "../utils/SpineUtils";
import {BenjiKIVGameAssets} from "../BenjiKIVGameAssets";
import {BenjiKIVSymbolStates} from "../../core/reel/ReelInterfaces";
import {BenjiKIVGameMode} from "../server/BenjiKIVGameMode";

export class BenjiKIVScatterSymbol extends BenjiKIVSymbol {

    private static ANIMATION_NAMES:string[] = ["S_Land_1", "S_Land_2", "S_Land_3", "S_Land_4", "S_Land_5", "S_Land_6", "S_Loop", "S_Loop2"];

    private _scatterAnimation:BenjiKIVSpine;
    private _isSpinning:boolean = false;
    private _diceValue:number = 0;

    constructor() {
        super();
        this.initAnimation();
    }

    private initAnimation():void {
        this._scatterAnimation = new BenjiKIVSpine(BenjiKIV.assetLoader.getSpineAsset(BenjiKIVGameAssets.SCATTER_SPINE));
        this._scatterAnimation.visible = false;
        this.addChild(this._scatterAnimation);
        this.addChild(this._darkOverlay);
    }

    public getNewStateAnimation(state:BenjiKIVSymbolStates, changeSpeed:number = 0, delay:number = 0, newStateAlpha:number = 1):gsap.core.Timeline {
        //Hide spine to show blurred sym on spin out
        if (state == BenjiKIVSymbolStates.SPIN && this._diceValue > 0){
            this.setState(BenjiKIVSymbolStates.NORMAL, "S/S_" + this._diceValue, 0);
            this._scatterAnimation.visible = false;
        }
        return super.getNewStateAnimation(state, changeSpeed, delay, newStateAlpha);
    }

    public setRestoreState(value:number):void{
        this._diceValue = value;
        this.setState(BenjiKIVSymbolStates.NORMAL, "S/S_" + this._diceValue, 0);
    }

    public playDiceSpinAnimation():void {
        if (this._scatterAnimation.visible == false){
            this._scatterAnimation.visible = true;
            SpineUtils.resetSpineAnimation(this._scatterAnimation);
            this._scatterAnimation.state.setAnimation(0, BenjiKIVScatterSymbol.ANIMATION_NAMES[6], true);
        }
    }

    public setDiceValue(value:number):void {
        this._diceValue = value;
        this._isSpinning = true;
        this._scatterAnimation.state.setAnimation(0, BenjiKIVScatterSymbol.ANIMATION_NAMES[value - 1], false);
        //If red xbet is on, next mode is FS or SFS and a scatter lands on a reel with multi enhancer, the enhancer should be re-activated
        if (BenjiKIV.model.isXBetRedSpecialMode == true && BenjiKIV.model.data.enhancerReel && BenjiKIV.model.data.enhancerReel[this.reelId] > 1){
            BenjiKIV.enhancerView.deActivateDarkOverlay(this.reelId);
        }
    }

    public reset() {
        super.reset();
        this._scatterAnimation.visible = false;
        this._isSpinning = false;
        this._diceValue = 0;
    }
}